import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/header.js";
import MobileMenu from "./MobileMenu.js";

export default class Header extends Component {
  // Define the method for opening the external link
  handleNavigate = () => {
    window.open(
      "https://bit-bangalore.irins.org/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  render() {
    return (
      <div>
        <Styles>
          <section className="top-bar">
            <Container>
              <Row>
                <Col lg="5">
                  <div className="logo">
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/general/logo.png"
                        }
                        style={{ width: "32.5rem", marginTop: "1rem" }}
                        alt="Logo"
                      />
                    </Link>
                  </div>
                </Col>
                <Col lg="6">
                  <div className="menu-box bar-right d-flex justify-content-center">
                    <ul className="nav menu-nav">
                      <li className="nav-item">
                        <div className="nav-link" style={{ color: "white" }}>
                          <i className="fas fa-phone" />
                          &nbsp;&nbsp;+91 77953 23103
                        </div>
                      </li>
                      <li className="nav-item">
                        <div className="nav-link" style={{ color: "white" }}>
                          <i className="far fa-clock" />
                          &nbsp;&nbsp;Library Hour: 08:30am - 8:30pm
                        </div>
                      </li>
                      <li className="nav-item">
                        <div className="nav-link" style={{ color: "white" }}>
                          |
                        </div>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="https://www.facebook.com/bitcentrallibraryofficial/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="https://www.instagram.com/bit_central_library/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="https://www.youtube.com/bitsince1979"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="header-area">
            <Container>
              <div className="row">
                <div className="offset-3 col-9">
                  <div className="menu-box d-flex justify-content-end">
                    <ul className="nav menu-nav">
                      <li className="nav-item active">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/library-librarian"}
                        >
                          Librarian & Staff
                        </Link>
                      </li>
                      <li className="nav-item active">
                        <a className="nav-link">Info Centre</a>
                        <ul className="dropdown list-unstyled">
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/library-rules"}
                            >
                              Rules & Regulations
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/library-committee"}
                            >
                              Library Committee
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              to={process.env.PUBLIC_URL + "/library-press"}
                            >
                              News Paper Clips
                            </Link>
                          </li>

                          <li className="nav-item">
                            <Link
                              className="nav-link"
                              onClick={this.handleNavigate}
                            >
                              IRINS Portal
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item active">
                        <Link
                          className="nav-link"
                          to={process.env.PUBLIC_URL + "/library-membership"}
                        >
                          Services
                        </Link>
                      </li>
                      <li className="nav-item active">
                        <Link
                          className="nav-link"
                          to={
                            process.env.PUBLIC_URL + "/library-itinfrastructure"
                          }
                        >
                          Digital Library
                        </Link>
                      </li>
                    </ul>
                    <div className="apply-btn">
                      <a
                        className="nav-link"
                        href="http://119.161.98.143:8082"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-clipboard-list"></i>OPAC
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </section>
        </Styles>
        <MobileMenu />
      </div>
    );
  }
}
